'use strict';
import util from '../../util';
import miniCart from '../../minicart';
import analytics from '../../analytics';

const basketProductLineItems = {};

const dialogSDK = {
    initPDP: async function () {
        const $dialogInput = $('.dialog-ask-anything-input');
        const $sendMessageButton = $('#send-message-button');
        const $masterID = $('.product-info .selected .swatchanchor').data('mpid') || $('.pdp-main').data('pid') && $('.pdp-main').data('pid').toString();
        const $selectedID = $('.product-info .selected .swatchanchor').data('pid') ? $('.product-info .selected .swatchanchor').data('pid').toString() : '' || $('.pdp-main').data('pid') && $('.pdp-main').data('pid').toString();
        const $prodName = $('.product-info-content .product-name') ? $('.product-info-content .product-name').text().trim() : '';

        $dialogInput.on("input", function () {
            if ($.trim($dialogInput.val()) !== '') {
                $sendMessageButton.prop('disabled', false);
            } else {
                $sendMessageButton.prop('disabled', true);
            }
        });

        try {
            const dialogClient = createDialogClient();
            const aiSuggestions = await fetchProductSuggestions(dialogClient, $masterID);
            if (aiSuggestions.questions.length < 1) {
                overrideDefaultQuestions(aiSuggestions);
            }

            renderAISuggestions(aiSuggestions, dialogClient);
            accessibilityEnhancements(dialogClient);
            // send message gtm event for input field available inside dialog
            dialogClient.onAssistantEvent((event) => {
                switch (event.type) {
                    case 'userSentMessage':
                        if ($("#dialog-ai-input").val() != undefined && $dialogInput.val() == "") {
                            analytics.sendAIDialogMessage();
                            $("#dialog-ai-input").val("");
                        }
                        break;
                }
            });

            // Namespaced off/on prevents duplicate listeners from repeated PDP/variant initializations
            $sendMessageButton.off('click.dialogAma').on('click.dialogAma', function () {
                const question = $.trim($dialogInput.val());

                // Guards against empty/duplicate sends if a stale handler still fires
                if (!question) {
                    return;
                }

                $dialogInput.val("");

                dialogClient.sendProductMessage({
                    question: question,
                    selectedVariantId: $selectedID,
                    productId: $masterID,
                    productTitle: $prodName
                });
                // send message gtm event for input field available on pdp page
                analytics.sendAIDialogMessage();

                // dialog modal open announcement for screen reader
                announceDialogModal();
            });

            $dialogInput.on('keydown', function (e) {
                if (e.key === 'Enter' || e.keyCode === 13) {
                    $sendMessageButton.click();
                }
            });
        } catch (error) {
            console.error('Failed to load AI suggestions:', error);
        }

        /**
         * Fetches AI-generated suggestions for a product
         */
        async function fetchProductSuggestions(dialogClient, productId) {
            return await dialogClient.getSuggestions(productId);
        }

        /**
         * Fallback questions if no suggestions are available
         */
        function overrideDefaultQuestions(suggestionsData) {
            suggestionsData.questions = [
                {
                    question: "What is the formula used in this repairing gel to soothe the skin after sun exposure?"
                },
                {
                    question: "How does this gel relieve sunburn and reduce pain?"
                },
                {
                    question: "What are the benefits for the skin after using this product following excessive exposure to UV rays?"
                }
            ];
        }

        /**
         * Renders assistant metadata and interactive suggestions
         */
        function renderAISuggestions(suggestionsData, dialogClient) {
            const $dialogInstantElement = $('#dialog-instant');
            const $assistantNameElement = $('#assistant-name');
            const $descriptionElement = $('#suggestions-description');
            const $suggestionsContainer = $('#dialog-suggestions-container');
            const $inputElement = $('.dialog-input-container input');

            $dialogInstantElement.addClass('show').removeClass('hide');

            if ($assistantNameElement.length) {
                $assistantNameElement.text(suggestionsData.assistantName);
            }

            if ($descriptionElement.length) {
                $descriptionElement.text(suggestionsData.description);
            }

            if ($inputElement.length) {
                $inputElement.attr('placeholder', suggestionsData.inputPlaceholder);
            }

            // Prevent duplicate rendering when init runs more than once.
            $suggestionsContainer.empty();

            const uniqueQuestions = [];
            const seenQuestions = new Set();

            (suggestionsData.questions || []).forEach((questionObj) => {
                const questionText = (questionObj && questionObj.question ? questionObj.question : '').trim();

                if (!questionText || seenQuestions.has(questionText)) {
                    return;
                }

                seenQuestions.add(questionText);
                uniqueQuestions.push(questionText);
            });

            uniqueQuestions.forEach((questionText, index) => {
                const $button = $(createSuggestionButton(questionText, dialogClient, index));
                $suggestionsContainer.append($button);
            });
        }

        /**
         * Creates a clickable suggestion button
         */
        function createSuggestionButton(questionText, dialogClient, index) {
            const $button = $('<button>', { class: 'dialog-suggestion' + ' suggestion_' + index.toString(), 'aria-label': questionText });
            const $icon = $('<img>', {
                src: window.Urls.starsImage,
                alt: $('#dialog-suggestions-container').data('img-alt')
            });
            const $label = $('<span>').text(questionText);

            $button.append($icon, $label);

            $button.on('click keydown', function (e) {
                if (e.type === 'click' || e.key === 'Enter' || e.keyCode === 13) {
                    announceDialogModal();
                    dialogClient.sendProductMessage({
                        question: questionText,
                        selectedVariantId: $selectedID,
                        productId: $masterID,
                        productTitle: $prodName
                    });
                }
            });

            return $button[0];
        }

        function accessibilityEnhancements(dialogClient) {
            bindSuggestionAccessibility(dialogClient, false);
        }

    },
    initPLP: function () {
        // PLP-specific initialization
        stickyDialog();
        initCommonPage();
    },
    initHP: function () {
        // HP-specific initialization
        stickyDialog();
        initCommonPage();
    }
};

// Initializes the Dialog client with callbacks
function createDialogClient() {
    return new window.DialogSDK.Dialog({
        apiKey: SitePreferences.DIALOG_SCRIPT_API,
        locale: window.User.locale.split("_")[0],
        theme: {
            primaryColor: '#000',
            ctaTextColor: '#ffffff',
            fontFamily: 'HelveticaNeueLT'
        },
        callbacks: {
            addToCart: async ({ productId, quantity, currency, variantId }) => {
                const csrfToken = $('meta[name="csrf-token"]').attr('content');
                const formData = new FormData();
                const productIdentifier = variantId || productId;

                formData.append('pid', productIdentifier);
                formData.append('format', 'ajax');
                formData.append(Constants.CSRF_TOKEN_NAME, csrfToken);
                formData.append('Quantity', quantity || 1);

                try {
                    const response = await fetch(window.Urls.addProduct, {
                        method: 'POST',
                        body: formData
                    });

                    const contentType = response.headers.get('content-type');

                    let productData;

                    if (contentType && contentType.includes('application/json')) {
                        productData = await response.json();

                        if (!productData.success) {
                            console.error('Failed to add product:', productData);
                            throw new Error(productData.message || 'Server responded with an error');
                        }
                        console.warn('Received JSON response instead of HTML. Not rendering mini cart.');
                    } else {
                        productData = await response.text();

                        if (!response.ok) {
                            console.error('Failed to add product:', productData);
                            throw new Error('Server responded with an error');
                        }
                        basketProductLineItems[productIdentifier] = productIdentifier;
                        miniCart.show(productData);
                        let dialogVariantColor = $("#dialog-drawer #Colour").val();
                        let dialogVariantSize = $("#dialog-drawer #Size").val();

                        // if ($('.pdp-page').length > 0) {
                        analytics.addProductAIDialogPDP(dialogVariantColor, dialogVariantSize);
                        // } else {
                        //     analytics.addProductAIDialog(productId, quantity, variantId);
                        // }

                        // selected variant product price

                        var price;
                        if ($('#dialog-drawer span').length > 0) {
                            price = $('#dialog-drawer span:last-child').filter(function () {
                                return /[\p{Sc}]\s?[\d]/u.test($(this).text());
                            }).first().text().trim().replace(/[^\d.,]/g, '');
                        }
                        else {
                            price = $('#dialog-ai-container span:last-child').filter(function () {
                                return /[\p{Sc}]\s?[\d]/u.test($(this).text());
                            }).first().text().trim().replace(/[^\d.,]/g, '');
                        }

                        const addToCartObj = analytics.trackCartAddition(productId, quantity, currency, price, variantId);

                        if (window.dialog && window.dialog.instance) {
                            window.dialog.instance.registerAddToCartEvent(addToCartObj);
                        }

                        setTimeout(function () {
                            $('html').removeClass('modal-open');
                        }, 1000);
                    }

                } catch (error) {
                    console.error('Could not add item to cart. Please try again later.', error);
                }
            },

            getProduct: async (productId, variantId) => {
                // Dialog passes productId as the master/product identifier; variantId is optional
                let productUrl = util.appendParamToURL(window.Urls.getProductDetails, 'pid', variantId || productId);
                // Some SFCC ajax-only endpoints require the format=ajax flag in addition to the XHR header
                productUrl = util.appendParamToURL(productUrl, 'format', 'ajax');

                try {
                    const response = await fetch(productUrl, {
                        method: 'GET',
                        cache: 'no-store',
                        headers: {
                            'Content-Type': 'application/json;charset=UTF-8',
                            'X-Requested-With': 'XMLHttpRequest'
                        }
                    });

                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }

                    const productData = await response.json();
                    return productData;
                } catch (error) {
                    console.log('Could not find any item. Please try again later.' + error);
                }
            }
        }
    });
}

// Handles dialog positioning and collapse behavior on PLP
const stickyDialog = () => {
    const $dialog = $('.dialog-container');
    const $toggle = $('.toggle-icon');
    const $suggestions = $dialog.find('.dialog-suggestion-wrapper');
    const $textDescription = $dialog.find('.dialog-question-text-description');
    const headerHeight = $('.header-container').outerHeight();
    const plpFilter = $('.pt_product-search-result .toolbar');

    let collapseTimer = null;
    let isCollapsed = false;

    const isDesktop = window.matchMedia("(min-width: 768px)").matches;
    const viewportMargin = isDesktop ? 20 : 12;
    const topMargin = ((plpFilter.length > 0 && !isDesktop) ? plpFilter.outerHeight() + headerHeight : headerHeight) + viewportMargin;

    const clearCollapseTimer = () => {
        if (collapseTimer) {
            clearTimeout(collapseTimer);
            collapseTimer = null;
        }
    };

    const updateAccessibilityState = (expanded) => {
        $toggle.attr('aria-expanded', expanded);
        $suggestions.attr('aria-hidden', !expanded);

        $suggestions.find('button')
            .attr('tabindex', expanded ? '0' : '-1');
    };

    const collapseDialog = () => {

        if (isCollapsed || !isDesktop) return;

        $dialog.addClass('is-collapsed');

        $suggestions.animate({ opacity: 0 }, 300, () => {
            $dialog.animate({
                top: topMargin,
                height: '50px',
                left: '20px',
                right: '79%',
                width: $('#assistant-name').outerWidth() + 80
            }, 400);

            $textDescription.animate({ opacity: 0 }, 200, function () {
                $(this).css('display', 'none');
            });
        });

        isCollapsed = true;
        updateAccessibilityState(false);
    };

    const expandDialog = () => {
        $dialog.removeClass('is-collapsed');

        setTimeout(() => {
            $dialog.animate({
                width: '1052px',
                top: topMargin,
                left: '0',
                right: '0'
            }, 400, function () {
                $(this).css('height', 'auto');

                $textDescription
                    .css('display', 'block')
                    .animate({ opacity: 1 }, 300);

                $suggestions.animate({ opacity: 1 }, 600);
            });
        }, 100);

        isCollapsed = false;
        updateAccessibilityState(true);

        $suggestions.find('button:visible').first().focus();
    };

    const startCollapseTimer = () => {
        clearCollapseTimer();
        if (!isDesktop) return;

        collapseTimer = setTimeout(collapseDialog, 6000);
    };

    //Toggle button (mobile)
    $toggle.on('click keydown', function (e) {
        if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;

        if (e.type === 'keydown') e.preventDefault();
        if (isDesktop) return;

        const isVisible = $suggestions.is(':visible');

        if (isVisible) {
            $suggestions.hide();
            $toggle.addClass('collapsed');
            updateAccessibilityState(false);
        } else {
            $suggestions.show();
            $toggle.removeClass('collapsed');
            updateAccessibilityState(true);

            $suggestions.find('button:visible').first().focus();
        }
    });

    //Dialog click (desktop expand)
    $dialog.on('click', () => {
        if (!isCollapsed || !isDesktop) return;

        expandDialog();
        clearCollapseTimer();
        collapseTimer = setTimeout(collapseDialog, 6000);
    });

    //Resize handling
    $(window).on('resize', () => {
        if (isDesktop) return;

        $dialog.removeClass('is-collapsed').removeAttr('style');

        clearCollapseTimer();
        isCollapsed = false;

        updateAccessibilityState(true);
    });

    //Intersection Observer to track sticky behaviour
    const callback = (entries) => {
        entries.forEach(({ isIntersecting }) => {
            if (isIntersecting) {
                $dialog.removeAttr('style').removeClass('is-fixed is-collapsed');
                $suggestions.removeAttr('style');
                $textDescription.removeAttr('style');

                if (!isDesktop) {
                    $suggestions.show().attr('aria-hidden', 'false');
                    $toggle.removeClass('collapsed').attr('aria-hidden', 'false');
                }

                clearCollapseTimer();
                isCollapsed = false;

                updateAccessibilityState(true);
                return;
            }

            $dialog.addClass('is-fixed').css('top', topMargin);

            if (!isDesktop) {
                $suggestions.hide().attr('aria-hidden', 'true');
                $toggle.addClass('collapsed').attr('aria-hidden', 'true');
                return;
            }

            if (!isCollapsed && !collapseTimer) {
                startCollapseTimer();
            }
        });
    };

    const options = {
        root: null,
        rootMargin: '-100px 0px 0px 0px',
        threshold: 0.0
    };

    const observer = new IntersectionObserver(callback, options);
    observer.observe(document.getElementById('observer-anchor'));

    updateAccessibilityState(true);
};

// Handles user sent message event to trigger analytics and clear input
const handleUserSentMessage = (event) => {
    if (event.type !== 'userSentMessage') {
        return;
    }

    const $aiInput = $('#dialog-ai-input');
    if ($aiInput.val() !== undefined) {
        analytics.sendAIDialogMessage();
        $aiInput.val('');
    }
};

const bindSuggestionAccessibility = (dialogClient, shouldSendProductMessage) => {
    $('#dialog-suggestions-container .dialog-suggestion').each(function () {
        const $button = $(this);
        const questionText = $button.text().trim();
        const type = $button.data('type');

        // Ensure accessibility attributes
        $button.attr({
            'aria-label': questionText
        });

        const handleAction = () => {
            const lastFocusedElement = document.activeElement;
            
            // announce when opening dialog from suggestion actions
            announceDialogModal();

            setTimeout(() => {
                // move focus to drawer
                const $dialog = $('#dialog-ai-chat-panel');
                $('#dialog-ai-chat-panel').find('button, a').attr('tabindex', 0);
                const $trigger = $('#dialog-ai-chat-panel a').last();

                const moveFocusToFirstButton = () => {
                    const $firstBtn = $('#dialog-ai-chat-panel')
                        .find('button:visible:not(:disabled)')
                        .first();

                    if ($firstBtn.length) {
                        $firstBtn.focus();
                    }
                };

                $trigger.off('keyup.dialogA11y').on('keyup.dialogA11y', function () {
                    moveFocusToFirstButton();
                });

                // ESC to close dialog
                $dialog.off('keydown.dialogA11y').on('keydown.dialogA11y', function (e) {
                    if (e.key === 'Escape') {
                        e.preventDefault();

                        // Trigger close button
                        const $closeBtn = $dialog.find('button[aria-label="Close"]');
                        if ($closeBtn.length) {
                            $closeBtn.click();
                        }
                    }
                });

                $dialog.find('button[aria-label="Close"]')
                    .off('click.dialogA11y keydown.dialogA11y')
                    .on('click.dialogA11y', function () {
                        // Close action can be mouse, Enter, or programmatic click from Escape.
                        setTimeout(() => {
                            restoreFocus();
                        }, 100);
                    })
                    .on('keydown.dialogA11y', function (e) {
                        if (e.key === 'Enter') {
                            const $focused = $(document.activeElement);
                            if ($focused.attr('aria-label') === 'Close') {
                                setTimeout(() => {
                                    restoreFocus();
                                }, 100);
                            }
                        }
                    });

                function restoreFocus() {
                    // Restore focus to the triggering suggestion button
                    if ($('.dialog-container').hasClass('is-collapsed')) {
                        $('.dialog-container').animate({
                            'width': '1052px',
                            left: '0',
                            right: '0'
                        }, 400, function () {
                            $(this).css('height', 'auto');
                            $('.dialog-question-text-description').css('display', 'block').animate(
                                { opacity: 1 },
                                300
                            );

                            $('.dialog-suggestion-wrapper').animate(
                                { opacity: 1 },
                                600
                            );
                        });
                    }

                    if (lastFocusedElement && lastFocusedElement.focus) {
                        lastFocusedElement.focus();
                    }
                }
            }, 2000);

            if (!shouldSendProductMessage) {
                return;
            }

            if (type === 'personal-shopper') {
                const personalShopperId = $button
                    .closest('.dialog-container')
                    .attr('data-id');

                window.dispatchEvent(
                    new CustomEvent('enableDialogAssistantEvent', {
                        detail: {
                            type: 'START_DIAGNOSTIC',
                            payload: {
                                buttonType: 'SIMPLE_BUTTON_DIAGNOSTIC',
                                personalShopperId: personalShopperId
                            }
                        }
                    })
                );
            } else {
                dialogClient.sendProductMessage({ question: questionText });
            }
        };

        // Avoid duplicate handlers if this initializer runs more than once.
        $button.off('click.dialogA11y keydown.dialogA11y');
        $button.on('click.dialogA11y', handleAction);
        $button.on('keydown.dialogA11y', (e) => {
            // Enter or Space should trigger action
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault(); // prevent page scroll for space
                handleAction();
            }
        });
    });
};

// Binds click events to suggestion buttons to send messages to the dialog
const bindSuggestionButtons = (dialogClient) => {
    bindSuggestionAccessibility(dialogClient, true);
};

// Initializes the Dialog client, fetches suggestions, and sets up the UI
const initCommonPage = async () => {
    try {
        const dialogClient = createDialogClient();
        bindSuggestionButtons(dialogClient);
        dialogClient.onAssistantEvent(handleUserSentMessage);
    } catch (error) {
        console.error('Failed to load AI suggestions:', error);
    }
};

function announceDialogModal() {
    const $dialogModal = $('#dialog-ai-container');
    if ($dialogModal.length) {
        const modalState = $dialogModal.attr('data-modal-state');

        if (modalState === 'CLOSED_VIEW') {
            $dialogModal.removeAttr('aria-live aria-atomic role');
            return;
        }

        if (modalState !== 'MESSAGES_VIEW') {
            return;
        }

        $dialogModal.attr('aria-live', 'polite');
        $dialogModal.attr('aria-atomic', 'true');
        $dialogModal.attr('role', 'alert');
    }
}

const dialogSDKInit = () => {
    const isDialogEnabled = SitePreferences.DIALOG_SCRIPT_ENABLED;
    const isPDP = $('.pt_product-details').length;
    const isCheckout = $('.checkout_page').length;

    if (!isDialogEnabled) {
        return;
    }

    if (isPDP) {
        dialogSDK.initPDP();
    } else if (!isCheckout) {
        createDialogClient();
    }
}

export default dialogSDKInit;
export { dialogSDK };